 const tiposRelatorios = [
    { "id": 1, "value": "Todos"},
    { "id": 2, "value": "Proposição"},
    { "id": 3, "value": "Parlamentar"},
];

export default tiposRelatorios